window.asyncImageComponent = {
    windowHeight: $(window).height(),
    loadAbstract: () => {
        $('img[data-wait=false]')
            .each(function () {
                $(this)
                    .attr(
                        "src",
                        $(this).data('src')
                    )
                    .removeAttr('data-src')
                    .on('error', function () {
                        let placeholderLink = $(this).data('placeholder') ? $(this).data('placeholder') : "/v2/dist/img/components/component-project-card-cover-placeholder.jpg";
                        $(this).attr('src', placeholderLink);
                    });
            });
    },
    lazyLoadAbstract: () => {
        let offsetTop = $(window).scrollTop(),
            $imgsToTreat =
                $('img[data-src]')
                    .filter(function () {
                        let elementOffsetTop = $(this).offset().top;

                        if ($(this).data('wait') === 'false') {
                            return false;
                        }

                        return (
                            elementOffsetTop >= offsetTop &&
                            elementOffsetTop <= asyncImageComponent.windowHeight + offsetTop
                        );
                    })
                    .each(function () {
                        $(this)
                            .attr(
                                "src",
                                $(this).data('src')
                            )
                            .removeAttr('data-src')
                            .on('error', function () {
                                let placeholderLink = $(this).data('placeholder') ? $(this).data('placeholder') : "/v2/dist/img/components/component-project-card-cover-placeholder.jpg";
                                $(this).attr('src', placeholderLink);
                            })
                        ;
                    });
    },
    load: () => {
        $('img[data-src]').each(function () {
            let placeholderLink = $(this).data('placeholder') ? $(this).data('placeholder') : "/v2/dist/img/components/component-project-card-cover-placeholder.jpg";
            $(this).attr('src', placeholderLink);
        });
        asyncImageComponent.loadAbstract();
        $(window).scroll(asyncImageComponent.lazyLoadAbstract);
    }
};

asyncImageComponent.load();
